const createFiatRampReport = ({
  fiatAssetsAtom,
  fiatCountriesAtom,
  fiatOrdersAtom,
  fiatUserAtom,
}) => ({
  namespace: 'fiatRamp',
  export: async () => {
    const unwrapResult = (result) => {
      if (result.status === 'rejected') return { error: result.reason }

      return result.value
    }

    const results = await Promise.allSettled([
      fiatAssetsAtom.get(),
      fiatCountriesAtom.get(),
      fiatOrdersAtom.get(),
      fiatUserAtom.get(),
    ])

    return {
      assets: unwrapResult(results[0]),
      countries: unwrapResult(results[1]),
      orders: unwrapResult(results[2]),
      user: unwrapResult(results[3]),
    }
  },
})

const fiatRampReportDefinition = {
  id: 'fiatRampReport',
  type: 'report',
  factory: createFiatRampReport,
  dependencies: ['fiatAssetsAtom', 'fiatCountriesAtom', 'fiatOrdersAtom', 'fiatUserAtom'],
  public: true,
}

export default fiatRampReportDefinition
